const UploadProgress = ({ progress = 0, error = null, fileName = '' }) => {
    if (error) {
        return (
            <div className="upload-progress">
                <div className="upload-progress-error" role="alert">
                    {fileName && <strong>{fileName}: </strong>}
                    {error}
                </div>
            </div>
        )
    }

    if (!progress || progress <= 0) {
        return null
    }

    const rounded = Math.min(100, Math.round(progress))
    const done = rounded >= 100

    return (
        <div className="upload-progress">
            {fileName && <div className="upload-progress-filename">{fileName}</div>}
            <div className="upload-progress-bar">
                <div
                    className={done ? 'upload-progress-bar-fill done' : 'upload-progress-bar-fill'}
                    style={{ width: `${rounded}%` }}
                >
                    {rounded > 15 && <span>{rounded}%</span>}
                </div>
            </div>
            <div className="upload-progress-status">
                {done ? 'Upload voltooid' : 'Bezig met uploaden…'}
            </div>
        </div>
    )
}

export default UploadProgress
